import React from 'react'
import { Chip, Avatar, Grid, ListItem, ListItemText, Stack, Typography, useTheme, SvgIcon, useMediaQuery } from '@mui/material'
import { getPricingPeriod, getRecurrenceText } from 'utils/service'
import HHDisplayMoney from 'components/common/HHDisplayMoney'
import ServiceActionTypeChip from 'components/services/ServiceActionTypeChip'
import ServiceMaterialTypeChip from 'components/services/ServiceMaterialTypeChip'
import MeasureChip from 'containers/new-route-manager/RouteCard/MeasureChip'
import { getMeasureUnit } from 'utils/get-measure-unit'
import BusinessLineChip from 'components/business-line/BusinessLineChip'
import { ReactComponent as RecurrenceIcon } from 'assets/Recurrence.svg'
import { ALPHA_38_PERCENT } from 'theme/colors'
import T from 'T'

const CSPricingListViewSmallCell = params => {
  const { row, totalPrice } = params
  const {
    businessLine,
    serviceName,
    recurrencePer: per,
    recurrenceInterval: interval,
    recurrenceFrequency: frequency,
    periodPer,
    periodInterval,
    value,
    materialType,
    materialColor = '#f1a050',
    actionType,
    volume,
    unit,
    zoneName,
  } = row || {}
  const theme = useTheme()
  const recurrenceText = getRecurrenceText(per, interval, frequency)
  const pricingPeriod = getPricingPeriod(periodPer, periodInterval)
  const measureText = volume ? `${volume} ${getMeasureUnit(unit)}` : ''
  const isDesktop = useMediaQuery(t => t.breakpoints.up('lg'))

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid container size={8}>
        <Grid size={12}>
          <ListItem disableGutters disablePadding>
            <ListItemText
              primary={
                <Typography gutterBottom variant="body1" color="textPrimary">
                  {serviceName}
                </Typography>
              }
              disableTypography
              secondary={
                <Stack direction="row" columnSpacing={0.5}>
                  {materialType && (
                    <ServiceMaterialTypeChip
                      sx={{
                        ...theme.typography.caption,
                        color: 'text.primary',
                      }}
                      display="inline-flex"
                      label={materialType}
                      materialColor={materialColor}
                      size="small"
                    />
                  )}
                </Stack>
              }
            />
          </ListItem>
        </Grid>
        <Grid size={12}>
          <ListItem disableGutters disablePadding>
            <ListItemText
              primary={
                <>
                  {isDesktop && (
                    <Stack
                      sx={{
                        mb: 0.5,
                        height: '24px',
                      }}
                      columnSpacing={0.5}
                      direction="row"
                      justifyContent="start"
                      mb={0.5}
                    >
                      {businessLine && <BusinessLineChip columnSpacing={0.5} direction="row" businessLineName={businessLine} />}
                      <Chip
                        size="small"
                        variant="outlined"
                        avatar={
                          <Avatar
                            sx={{
                              backgroundColor: `${theme.palette.background.black}${ALPHA_38_PERCENT}`,
                            }}
                          >
                            <SvgIcon inheritViewBox sx={{ fontSize: 12, color: theme.palette.background.paper }}>
                              <RecurrenceIcon />
                            </SvgIcon>
                          </Avatar>
                        }
                        label={recurrenceText}
                      />
                    </Stack>
                  )}
                </>
              }
              disableTypography
              secondary={
                <>
                  {isDesktop && (
                    <Stack direction="row" spacing={0.5} justifyContent="start">
                      {measureText && <MeasureChip measureUnit={unit} label={measureText} />}
                      {actionType && <ServiceActionTypeChip action={actionType} size="small" />}
                      {zoneName && <Chip size="small" label={zoneName} />}
                    </Stack>
                  )}
                </>
              }
            />
          </ListItem>
        </Grid>
      </Grid>
      <Grid size={4} container alignItems="center">
        <ListItem>
          <ListItemText
            primary={<HHDisplayMoney value={totalPrice ?? value} formatToDollars={false} />}
            secondary={totalPrice != null ? T.TOTAL : pricingPeriod}
            slotProps={{
              primary: {
                variant: 'h5',
                fontWeight: 700,
                textAlign: 'right',
                color: 'textPrimary',
                whiteSpace: 'nowrap',
              },
              secondary: {
                variant: 'body1',
                fontWeight: 400,
                color: 'textSecondary',
                textAlign: 'right',
                whiteSpace: 'nowrap',
              },
            }}
          />
        </ListItem>
      </Grid>
    </Grid>
  )
}

CSPricingListViewSmallCell.propTypes = {}

export default CSPricingListViewSmallCell
